function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    className: "w-6 h-6",
    xmlSpace: "preserve",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 11.964946,8.6699124 c -2.7545223,0 -4.4537939,2.2657076 -4.4634854,5.0243426 H 1.93963 l 0,-6.204479 0,-1.7643622",
    id: "path907"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 8.6231743,3.4352483 v 1.261928",
    id: "path911"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 15.330088,3.3184031 -0.02337,1.261928",
    id: "path913"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 22.037001,5.7254138 0,1.8461538 0,6.1460564 H 16.47517 C 16.45278,10.846374 14.840398,8.7327216 11.964946,8.6699124",
    id: "path915"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 21.990263,7.7351509 c -6.574489,-3.902629 -13.2424538,-4.2064265 -20.0038949,0",
    id: "path1017"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 8.602883,17.036027 h 4.574175",
    id: "path1068"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 11.913661,20.331061 h 3.537818",
    id: "path1068-3"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.93bf3cab90d49bd808a32d52f5018968.svg";
export { ForwardRef as ReactComponent };